import * as React from 'react';
import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import VoxelDialog from '../../../../voxel/Dialogs/VoxelDialog';
import VoxelDialogActionCancel from '../../../../voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActions from '../../../../voxel/Dialogs/VoxelDialogActions';
import VoxelDialogActionSubmit from '../../../../voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogContent from '../../../../voxel/Dialogs/VoxelDialogContent';
import VoxelText from '../../../../voxel/Text/VoxelText';
import { KeywordTableState } from '../logic/useKeywordTableState';
import { KeywordTableColumnTypes } from '../KeywordTableColumnPicker/models';

export interface TranslateDialogProps {
  tableState: KeywordTableState;
  selectedCount?: number;
  reload?: () => Promise<any>;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const TranslateDialog: React.FC<TranslateDialogProps> = ({
  tableState,
  reload,
  open,
  setOpen,
  selectedCount,
}) => {
  // Translate keywords
  const mutation =
    projectsApiService.mutations.translate.useTranslateProjectKeywordsToEnglishTrigger();
  const [loading, setLoading] = useState(false);
  const handleAction = useCallback(() => {
    setLoading(true);
    tableState.setTableUIState((prev) => ({ ...prev, showEnglish: true }));
    setOpen(false);
    mutation({
      keywordQuery: {
        filtering: tableState.backendFilterState,
        selecting: { emptyIsAll: true, invertSelection: false, keywordIds: [] },
      },
    })
      .then(reload)
      .then(tableState.handleResetSelection)
      .then(() =>
        tableState.columnPickerBag.toggleColumn(KeywordTableColumnTypes.EnglishTranslation, true)
      )
      .finally(() => setLoading(false));
  }, [tableState.backendFilterState, tableState.selectionState, reload]);

  return (
    <VoxelDialog
      open={open}
      onClose={() => setOpen(false)}
      title={`Translate all keywords to english`}
    >
      <VoxelDialogContent>
        <VoxelText>
          This adds an english translation in a separate column. Keywords that already have a
          translation won't be translated again
        </VoxelText>
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={() => setOpen(false)} disabled={loading}>
          Cancel
        </VoxelDialogActionCancel>
        <VoxelDialogActionSubmit onClick={handleAction} title={'Translate'} disabled={loading} />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default TranslateDialog;
